var map = {
	"./2.png": "lwIr",
	"./banner2.png": "QFm/",
	"./counselor2.png": "EYnw",
	"./info2.png": "JL3E",
	"./service2.png": "Ot6T",
	"./system2.png": "F2sw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Cnje";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/.*2\.png$
// module id = Cnje
// module chunks = 1